// extracted by mini-css-extract-plugin
module.exports = {"container":"UgcSectionTitle_container__RwWDc","title":"UgcSectionTitle_title___vIDs","trustpilot":"UgcSectionTitle_trustpilot__rzgEB"};